module.exports = __webpack_public_path__ + "static/media/doc.b0eb7045.svg";